var _defs, _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarktplatzProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 267.27 181.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{stroke:#1d1d1b;stroke-width:.5px;}.cls-1,.cls-2{fill:none;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-1,.cls-4{opacity:.75;}.cls-5,.cls-3{fill:#fff;}.cls-2{stroke:#1e3d7c;}.cls-6{fill:#dadada;}.cls-3{stroke:#dadada;stroke-width:3px;}.cls-7{fill:#203c7e;}.cls-8{fill:#48ae54;}\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    x2: 265.77,
    y1: 154.23,
    y2: 154.23
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 178.47,
    rx: 0.91,
    ry: 0.91,
    width: 264.27,
    x: 1.5,
    y: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 66.33,
    rx: 0.91,
    ry: 0.91,
    width: 112.36,
    x: 13.06,
    y: 87.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 4.25,
    rx: 0.91,
    ry: 0.91,
    width: 4.25,
    x: 254.62,
    y: 9.38
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    height: 10.4,
    rx: 0.91,
    ry: 0.91,
    width: 23.43,
    x: 213.78,
    y: 104.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 12,
    rx: 0.91,
    ry: 0.91,
    width: 43.47,
    x: 9.3,
    y: 160.94
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 14.4,
    rx: 0.91,
    ry: 0.91,
    width: 55.13,
    x: 204.17,
    y: 159.74
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 4.36,
    rx: 0.91,
    ry: 0.91,
    width: 28.66,
    x: 213.78,
    y: 92.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 5.84,
    rx: 0.91,
    ry: 0.91,
    width: 30.19,
    x: 141.56,
    y: 58.88
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 11.67,
    rx: 0.91,
    ry: 0.91,
    width: 43.26,
    x: 20.2,
    y: 23.97
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 3.76,
    rx: 0.91,
    ry: 0.91,
    width: 41.23,
    x: 69.36,
    y: 28.12
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 11.67,
    rx: 0.91,
    ry: 0.91,
    width: 46.68,
    x: 66.89,
    y: 23.97
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 3.76,
    rx: 0.91,
    ry: 0.91,
    width: 62.84,
    x: 120.12,
    y: 28.31
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 11.67,
    rx: 0.91,
    ry: 0.91,
    width: 69.23,
    x: 117.07,
    y: 24.16
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 3.76,
    rx: 0.91,
    ry: 0.91,
    width: 32.22,
    x: 195.1,
    y: 28.12
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 11.67,
    rx: 0.91,
    ry: 0.91,
    width: 43.34,
    x: 189.87,
    y: 23.97
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 5.48,
    rx: 0.91,
    ry: 0.91,
    width: 5.48,
    x: 149.56,
    y: 91.47
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 4.46,
    rx: 0.91,
    ry: 0.91,
    width: 35.85,
    x: 157.62,
    y: 91.98
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 4.46,
    rx: 0.91,
    ry: 0.91,
    width: 35.85,
    x: 157.95,
    y: 108.15
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 4.46,
    rx: 0.91,
    ry: 0.91,
    width: 35.85,
    x: 149.56,
    y: 124.01
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 5.35,
    rx: 0.91,
    ry: 0.91,
    width: 39.43,
    x: 149.56,
    y: 75.42
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 5.35,
    rx: 0.91,
    ry: 0.91,
    width: 39.43,
    x: 9.3,
    y: 9.38
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 5.48,
    rx: 0.91,
    ry: 0.91,
    width: 5.48,
    x: 149.56,
    y: 107.65
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.15,
    rx: 0.91,
    ry: 0.91,
    width: 46.64,
    x: 208.42,
    y: 164.92
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.15,
    rx: 0.91,
    ry: 0.91,
    width: 31.68,
    x: 26.11,
    y: 27.74
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarktplatzProject);
export default __webpack_public_path__ + "static/media/marktplatz-project.f4679511b2a7ca35b43915f61e9b7050.svg";
export { ForwardRef as ReactComponent };